import React from 'react';
import "../../assets/scss/components/form/switch.scss"

const Switch = ({children, ...props}) => {
    return (
        <div className="switch-wrapper">
            <span className="switch-title">{props.title}</span>
            <label className="switch">
                {children}
                <span className="switch-slider"></span>
            </label>
        </div>
    );
};

export default Switch;
